import React, {Component, Fragment,} from "react";
import moment from "moment";


interface DurationCellContentProps
{
    from: moment.Moment | Date | string | null | undefined;
    to: moment.Moment | Date | string | null | undefined;
}

interface DurationCellContentState
{
}

export default class DurationCellContent extends Component<DurationCellContentProps,DurationCellContentState>
{
    constructor(props: Readonly<DurationCellContentProps>) {
        super(props);

        this.state = {
        };
    }

    public render()
    {
        if(this.props.from === undefined || this.props.from ===  null || this.props.to === undefined || this.props.to === null)
        {
            return null;
        }
        
        const diff = moment(this.props.to).diff(this.props.from);
        const duration = moment.duration(diff);
        const durationHuman = moment.duration(diff).humanize();
        
        return (
            <Fragment>
                <span>{durationHuman}</span>
                <span className={"cdb-table__extra-detail"}>{duration.days().toString().padStart(2,"0")}:{duration.hours().toString().padStart(2,"0")}:{duration.minutes().toString().padStart(2,"0")}:{duration.seconds().toString().padStart(2,"0")}</span>
            </Fragment>
        )
    }
}